<div class="dialog-container">
  <!--close icon-->
  <div class="close">
    <payee-icon
      class="pointer"
      [name]="'cross-black'"
      (click)="onClose()"
    ></payee-icon>
  </div>

  <!--title-->
  <div class="new-big-title top-margin-10">{{ debtorFormService.title }}</div>

  <!--description-->
  <div class="new-big-description top-margin-20">
    Melyik céggel, egyéni vállalkozóval vagy magánszeméllyel szemben áll fenn a
    követelés, azaz ki az adós az ügyben?
  </div>

  <!--debtor-->
  <div class="top-margin-30 bottom-margin-30">
    <app-debtor-data-box></app-debtor-data-box>
  </div>

  <!--save button-->
  <div class="close top-margin-30">
    <div class="save-button">
      <button
        payee-button
        [loading]="debtorFormService.saveLoading"
        (click)="onSave()"
        width="shorter"
        height="tall"
      >
        Mentés
      </button>
    </div>
  </div>
</div>
